import { CreditCard, Video, MessageCircle, Sparkles, Mail } from "lucide-react";

const INTEGRATIONS = [
  { icon: CreditCard, name: "Razorpay", desc: "UPI, cards, netbanking, wallets. Auto-invoice.", status: "mock" },
  { icon: Video, name: "Zoom (Server-to-Server OAuth)", desc: "Shared license pool. Unique join links per attendee.", status: "mock" },
  { icon: MessageCircle, name: "Nextel WhatsApp Cloud", desc: "Meta-approved BSP. Pre-approved template IDs.", status: "mock" },
  { icon: Mail, name: "Resend (Email)", desc: "Branded HTML templates. High deliverability.", status: "mock" },
  { icon: Sparkles, name: "Kimi API (AI Content)", desc: "Currently powered by Emergent Universal Key + Claude Sonnet 4.5.", status: "live" },
];

export default function Integrations() {
  return (
    <div className="space-y-6 vp-fade-up">
      <div>
        <div className="vp-label">Integrations</div>
        <h1 className="font-display text-3xl font-bold mt-1">Connected services</h1>
        <p className="text-[#4A4D57] mt-1 text-sm">All flows run in mock mode by default. Drop real keys in <code>backend/.env</code> and flip <code>INTEGRATIONS_MODE=live</code>.</p>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        {INTEGRATIONS.map((it) => (
          <div key={it.name} className="vp-glass p-5 flex items-start gap-4">
            <div className="w-11 h-11 rounded-xl bg-[#0B5CFF]/20 border border-[#0B5CFF]/40 flex items-center justify-center">
              <it.icon className="w-5 h-5 text-[#0B5CFF]" strokeWidth={1.5} />
            </div>
            <div className="flex-1">
              <div className="flex items-center gap-3">
                <div className="font-display font-semibold text-lg">{it.name}</div>
                <span className={"vp-chip " + (it.status === "live" ? "text-[#1E8E3E]" : "text-[#0B5CFF]")}>{it.status}</span>
              </div>
              <p className="text-sm text-[#4A4D57] mt-1">{it.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
